import { render, staticRenderFns } from "./Dsp2.vue?vue&type=template&id=1ab35a3c"
import script from "./Dsp2.vue?vue&type=script&lang=ts"
export * from "./Dsp2.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ab35a3c')) {
      api.createRecord('1ab35a3c', component.options)
    } else {
      api.reload('1ab35a3c', component.options)
    }
    module.hot.accept("./Dsp2.vue?vue&type=template&id=1ab35a3c", function () {
      api.rerender('1ab35a3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "checkout/Dsp2.vue"
export default component.exports